(function($) {
  'use strict';

  const header = {
    dom: function() {
      this.$html = $('html');
      this.$utility = $('#utility');
      this.$utilityBreadcrumb = $('#utilityBreadcrumb');
      this.$header = $('#header');
      this.$mainNav = $('#main-nav');
    },

    heights: function() {
      this.$html.css('--jd-utility-height', (this.$utility.length && this.$utility.is(':visible') ? Math.floor(this.$utility.outerHeight()) : 0) + 'px');
      this.$html.css('--jd-header-height', (this.$header.length && this.$header.is(':visible') ? Math.floor(this.$header.outerHeight()) : 0) + 'px');
      this.$html.css('--jd-sticky-header-height', (this.$header.length && this.$header.is(':visible') ? Math.floor(this.$header.find('.header__columns').outerHeight()) : 0) + 'px');
      this.$html.css('--jd-nav-height', (this.$mainNav.length && this.$mainNav.is(':visible') ? Math.floor(this.$mainNav.outerHeight()) : 0) + 'px');
    },

    utilityNav: function() {
      if (!this.$utility.length) { return; }
      const $breadcrumb = this.$utilityBreadcrumb;
      const listingText = $breadcrumb.data('listing-text');
      const searchText = $breadcrumb.data('search-text');
      if (storage.get('community-filters')) {
        $breadcrumb.text(searchText);
      }
      else if (storage.get('corporate')) {
        $breadcrumb.text(listingText);
      }
      else {
        $breadcrumb.parent().remove();
      }
    },

    headerStuck: function() {
      const observer = new IntersectionObserver(
        ([e]) => {
          if (!jcms.stickyHeader || (jcms.stickyHeader === 'desktop_only' && $(window).width() <= jcms.mobileBreak)) {
            return;
          }

          if (e.isIntersecting) {
            header.$html.removeClass('header-stuck');
          }
          else {
            header.$html.addClass('header-stuck');
          }
        },
        {
          rootMargin: '-3px 0px 0px 0px',
          threshold: [1]
        }
      );

      observer.observe(this.$header.get(0));
    },

    ready: function() {
      this.dom();
      this.heights();
      this.utilityNav();
      this.headerStuck();
    }
  };

  $(function() { header.ready(); });

  $(window).on('load resize scroll', function(event) {
    if (event.type != 'scroll') {
      header.heights();
    }
    else {
      header.$html.css('--jd-sticky-header-height', (header.$header.length && header.$header.is(':visible') ? Math.floor(header.$header.find('.header__columns').outerHeight()) : 0) + 'px');
    }
  });

})(jQuery);
